import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=8af93dcc&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=ts"
export * from "./Placeholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af93dcc",
  null
  
)

export default component.exports